import {
  AvatarCircle,
  PopupListContainer,
  TeamDetailsHeader,
  TeamMembersDropDown,
} from './styles/TeamVacationCircle.styled';
import { formatDate } from 'src/utils/dateFns/formatDate';
import { truncateString } from 'src/utils/truncateString';
import { CurrentUserVacationInformation } from './CurrentUserVacationInformation';
import { Tooltip } from '@fluentui/react-components';
import {
  DAY_POSITION_DIVIDER,
  EMPLOYEE_NAME_MAX_LENGTH,
  VACATION_TYPE_LENGTH,
} from 'src/tabs/constants/Timeoff.constants';

interface TeamVacationPopupProps {
  month: number;
  employeesOverflow?: {
    name: string;
    colorPersona: string;
    backgroundPersona: string;
  }[];
  date: string;
  currentUser: {
    name: string;
    target: Element;
    date: string;
    status: string;
    vacationType: string;
  };
}

export const TeamVacationPopup = ({
  employeesOverflow,
  date,
  currentUser,
}: TeamVacationPopupProps) => {
  const {
    year,
    month: monthString,
    day,
  } = formatDate(new Date(date || currentUser.date));
  const vacationType = truncateString(
    currentUser?.vacationType?.replace('Time-off', 'Time off') ?? '',
    VACATION_TYPE_LENGTH
  );

  const position = +day < DAY_POSITION_DIVIDER ? 'top' : 'bottom';

  return (
    <TeamMembersDropDown position={position}>
      <TeamDetailsHeader>
        &nbsp;{`${day}/${monthString}/${year}`}
      </TeamDetailsHeader>
      {currentUser.name === 'currentUser' && (
        <CurrentUserVacationInformation
          isOnlyCurrentUserOnVacation={employeesOverflow.length === 0}
          currentUser={currentUser}
          vacationType={vacationType}
        />
      )}
      <PopupListContainer>
        {employeesOverflow.map((employee) => {
          const nameArray = employee.name.split(' ');
          const initials = nameArray[1]
            ? nameArray[0][0] + nameArray[1][0]
            : nameArray[0][0];
          return (
            <li key={employee.name}>
              {employee.name.length > EMPLOYEE_NAME_MAX_LENGTH - 1 ? (
                <Tooltip content={employee.name} relationship={'description'}>
                  <span>
                    <AvatarCircle
                      background={employee.backgroundPersona}
                      color={employee.colorPersona}
                    >
                      <p>{initials}</p>
                    </AvatarCircle>
                    {truncateString(employee.name, EMPLOYEE_NAME_MAX_LENGTH)}
                  </span>
                </Tooltip>
              ) : (
                <span>
                  <AvatarCircle
                    background={employee.backgroundPersona}
                    color={employee.colorPersona}
                  >
                    <p>{initials}</p>
                  </AvatarCircle>
                  {employee.name}
                </span>
              )}
            </li>
          );
        })}
      </PopupListContainer>
    </TeamMembersDropDown>
  );
};
